import _InputWrapper from './components/InputWrapper';
import _useGlobalForm from './hooks/use-global-form';
import _useLocalForm from './hooks/use-local-form';
import * as validators from './validation';
import * as validationHelpers from './validation/helpers';

export const useGlobalForm = _useGlobalForm;

export const useLocalForm = _useLocalForm;
export { reducers } from './reducers';
export { selectResourceForKey } from './selectors';

export const validation = {
	...validators,
	...validationHelpers,
};

export const InputWrapper = _InputWrapper;
export * from './utilities/getters';

export default _useLocalForm;

export * from './types';
